// Modules
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdKmSgApi } from "_Route/Api";

// Component
import AdKMView from "./AdKMView";
import AdKMMenu from "./AdKMMenu";


const AdKMDt = () => {

  const location = useLocation();
  const params = useParams();

  const sessionID = localStorage.getItem('memSessionID')
  const kmSpace = sessionStorage.getItem('kmSpace')
  const curType = location.pathname.split('/')[3] === 'add' ? '등록' : '수정';

  const [guideStatus, setGuideStatus] = useState(true);
  const [curTitle, setCurTitle] = useState(''); // 현재 메뉴의 타이틀
  const [curSpace, setCurSpace] = useState(kmSpace || ''); // 현재 선택된 Space (default 전체)
  const [update, setUpdate] = useState(false);
  const [updateMenu, setUpdateMenu] = useState(false);
  
  
  // KM GET (현재 메뉴)
  useEffect(() => {
    axios.get(AdKmSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        km_id: params.id
      }
    })
    .then(res => {
      const result = res.data.result[0];
      setCurTitle(result?.km_title)
    })
    .catch(err => {
      console.error(err, "GET Category List Error...");
    })
  }, [location])

  
  return (
    <>
      <div className="adContTitGroup">
        <h2>KM {`${params.id ? '' : '새'} 메뉴 ${curType} ${params.id ? `- ${curTitle || ''}` : ''}`}</h2>
        <p>Home / KM / KM 메뉴 관리 / <strong>{`${params.id ? '' : '새'} 메뉴 ${curType} ${params.id ? `- ${curTitle || ''}` : ''}`}</strong> <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>
        
        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 메뉴를 <span className="blueTxt">드래그 앤 드롭</span>하여 메뉴간의 위치를 변경할 수 있습니다.</li>
          <li>* 메뉴의 <span className="blueTxt">+ 버튼</span>을 클릭하여 해당 메뉴의 <span className="blueTxt">하위 메뉴를 생성</span>할 수 있습니다.</li>
        </ul>
      </div>

      <div className="adContGroup">
        <DndProvider backend={HTML5Backend}>
          <AdKMMenu
            curSpace={curSpace}
            setCurSpace={setCurSpace}
            update={update}
            setUpdate={setUpdate}
            updateMenu={updateMenu}
          />

          <AdKMView
            curSpace={curSpace}
            setUpdate={setUpdate}
            update={update}
            setUpdateMenu={setUpdateMenu}
            updateMenu={updateMenu}
          />
        </DndProvider>
      </div>
    </>
  )
}

export default AdKMDt;